import { render, staticRenderFns } from "./GateArr.vue?vue&type=template&id=56bdcab4&scoped=true&"
import script from "./GateArr.vue?vue&type=script&lang=js&"
export * from "./GateArr.vue?vue&type=script&lang=js&"
import style0 from "./GateArr.vue?vue&type=style&index=0&id=56bdcab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bdcab4",
  null
  
)

export default component.exports